import { motion } from 'framer-motion'
import React from 'react'
import StyledButton from './styled-button'

const MotionButton = StyledButton.withComponent(motion.button)

/**
 * Button styled with animation.
 * * This component receives the properties which are diffined into StyledButton
 * @param {Object} props
 * @param {boolean} props.outline
 */
const Button = (props) => {
  const scaleHover = props.disabled ? 1 : 1.02
  const scaleTap = props.disabled ? 1 : 0.97

  return (
    <MotionButton
      whileHover={{ scale: scaleHover }}
      whileTap={{ scale: scaleTap }}
      {...props}
    >
      {props.children}
    </MotionButton>
  )
}

export default Button
